import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Обработчик роутинга для корректного учёта навигации Яндекс метрики в SPA */
export const useYandexMetrika = () =>{
  const location = useLocation()

  useEffect(()=>{
    // @ts-ignore
    if (window?.ym && typeof window?.ym === 'function') {
      // @ts-ignore
      window?.ym(99249204, 'hit', location.pathname + location.search);
    }
  }, [location])
}